import React from 'react';

export const PlusIcon: React.FC<sharedComponents.SvgIcon> = ({ className, width = 28, height = 28 }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={`${width}px`}
    height={`${height}px`}
    viewBox="0 0 28 28"
    fill="none"
  >
    <path d="M14 0C6.3 0 0 6.3 0 14C0 21.7 6.3 28 14 28C21.7 28 28 21.7 28 14C28 6.3 21.7 0 14 0ZM19.4 14.5H14.5V19.4C14.5 19.7 14.3 19.9 14 19.9C13.7 19.9 13.5 19.7 13.5 19.4V14.5H8.6C8.3 14.5 8.1 14.3 8.1 14C8.1 13.7 8.3 13.5 8.6 13.5H13.5V8.6C13.5 8.3 13.7 8.1 14 8.1C14.3 8.1 14.5 8.3 14.5 8.6V13.5H19.4C19.7 13.5 19.9 13.7 19.9 14C19.9 14.3 19.6 14.5 19.4 14.5Z" fill="#5514B4" />
  </svg>
);
